import { TableColumnConfig } from "../../../../types/table";

export const getCellSizeProps = (column: TableColumnConfig<never>) => {
  if (typeof column.colSpan === "number") {
    return { colSpan: column.colSpan };
  }

  return {
    style: {
      width: column.width,
    },
  };
};
